(function( $ ){ 
    var options = {
            listenMethods: ['append', 'prepend', 'after', 'before', 'insertAfter', 'insertBefore', 'remove', 'show'],
            container: '<span class="customselect customselect-container"></span>',
            text: '<span class="customselect-textbox"><span class="customselect-value"></span><span class="customselect-arrow"></span></span>',
        },
        methods = { 
            init : function(options) {
                var _this = this;

                if($.fn.customselectmethods !== true) {
                    $.fn.extend({
                        customselectmethods: true
                    });

                    methods.extendJquery.call(_this);
                    methods.addEventListeners.call(_this);
                }
                else {
                    methods.update.call(_this);
                }
                
                return _this.each(function(){
                    methods.generateSelect.call(this);
                });                
            },
            update: function(selects) {
                var _this = this;

                return _this.each(function(){
                    methods.updateContent.call(this);
                }); 
            },
            extendJquery: function(){
                var newMethods = {},
                    jQueryOriginalMethods = {},
                    _this = this;

                $.each(options.listenMethods, function(key, method){
                    jQueryOriginalMethods[method] = $.fn[method];

                    newMethods[method] = function(){
                        var select = null;
                        var _this = this;

                        if($(_this).length > 0 && _this.prop('tagName')) {
                            if(_this.prop('tagName').toLowerCase() == 'select'){
                                select = $(_this);
                            }
                            else if(_this.prop('tagName').toLowerCase() == 'option') {
                                select = $(_this).parent();
                            }
                            else {
                                select = $(_this).find('select');
                            }
                        }          

                        jQueryOriginalMethods[method].apply(_this, arguments);


                        if(select) {
                            $(select).each(function(){
                                methods.updateContent.call($(this));
                            });
                        }

                        return _this;
                    }
                });                

                $.fn.extend(newMethods);

                $.propHooks.disabled = {
                    set: function(el, value){
                        if (el.disabled !== value) {
                            el.disabled = value;

                            if($(el).prop('tagName').toLowerCase() == 'select') {
                                methods.updateContent.call($(el));
                            }
                            else if($(el).prop('tagName').toLowerCase() == 'option') {
                                methods.updateContent.call($(el).closest('select'));
                            }                            
                        }
                    }
                }

                $.propHooks.selected = {
                    set: function (el, value) {
                        if (el.selected !== value) {
                            el.selected = value;

                            if($(el).prop('tagName').toLowerCase() == 'select') {
                                methods.updateContent.call($(el));
                            }
                            else if($(el).prop('tagName').toLowerCase() == 'option') {
                                methods.updateContent.call($(el).closest('select'));
                            }                              
                        }
                    }
                };
            },
            addEventListeners: function(){
                $(document)
                    .on('change', '.customselect-select', function(e){
                        var href = $(this).find('option:selected').attr('href');
                        if(href) {
                            window.location = href;
                        }

                        methods.updateContent.call(this);
                    })
                    .on('focus click', '.customselect-select', function(){
                        var container = $(this).closest('.customselect-container');
                        container.addClass('customselect-focus');
                    })
                    .on('blur', '.customselect-select', function(){
                        var container = $(this).closest('.customselect-container');
                        container.removeClass('customselect-focus');
                    })
                    .on('click focus touchstart', 'select[disabled]', function(e){
                        e.preventDefault();
                    });

                $(window).on('resize', function(){
                    $('.customselect-select').each(function(){
                        methods.updateContent.call(this);
                    });
                });
            },
            generateSelect: function(callback){
                if(!$(this).hasClass('customselect-select')) {
                    var classes = $(this).attr('class');
                    $(this).addClass('customselect-select');

                    var selectEL = $(this).wrap(options.container);
                    $(options.text).insertBefore(selectEL);

                    methods.updateContent.call(this);
                }
            },
            updateContent: function(){
                var container = $(this).closest('.customselect-container'),
                    selected = $(this).find('option:selected'),
                    select = container.find('select');

                // set text
                var text = selected.text();

                if(!text) {
                    text = '&nbsp;';
                }

                container.find('.customselect-value').html(text);

                container.toggleClass('customselect-option-disabled', !!(selected.attr('customselect-disabled')));

                // set disabled status
                container.toggleClass('customselect-disabled', select.is(':disabled'));

                // set width
                container.removeAttr('style').find('select').removeAttr('style');

                var selectWidth = select.outerWidth(),
                    arrowWidth = container.find('.customselect-arrow').outerWidth(),
                    maxWidth = container.innerWidth(),
                    maxCSSWidth = parseInt(select.css('max-width'));

                select.width(selectWidth);
                selectWidth = select.width()+arrowWidth;

                if(selectWidth > maxWidth) {
                    selectWidth = maxWidth;
                }

                if(selectWidth > maxCSSWidth) {
                    selectWidth = maxCSSWidth;
                }

                // TODO; misschien deze width fixen, misschien niet nodig
                //container.css('width', selectWidth);
                select.css({'width': '100%'});
            },
        };

    $.fn.customselect = function(methodOrOptions) {
        if ( methods[methodOrOptions] ) {
            return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));
        } else if ( typeof methodOrOptions === 'object' || ! methodOrOptions ) {
            return methods.init.apply( this, arguments );
        } else {
            $.error( 'Method ' +  methodOrOptions + ' does not exist on jQuery.customselect' );
        }    
    };
})( jQuery );